import SolutionBriefing from './SolutionBriefing';

export default SolutionBriefing;
